<script>
import Status from '@/Shared/Status';
import AuctionState from "@/mixins/AuctionState";
import { Link } from "@inertiajs/vue2";

export default {
    name: "RunningAuctionsBanner",
    components: {
        AuctionState,
        Status,
        Link
    },
    mixins: [AuctionState],
    props: {
        auctions: {
            type: Array,
            default: []
        }
    }
}
</script>

<template>
    <div class="flex flex-col sm:flex-row sm:justify-between gap-y-2 sm:gap-y-0 items-center bg-gray-200 p-2 text-gray-600 mb-3 text-sm border-l-4 border-green-600">
        <div class="flex justify-end font-bold py-1 md:py-0 w-full sm:w-auto">
            Laufende Auktionen ({{ auctions.length }}):
        </div>
        <div class="flex flex-col gap-y-4 w-full sm:w-auto">
            <div v-for="auction in auctions" :key="auction.id" class="flex flex-row justify-end gap-x-4 items-center">
                <div>
                    <Link :href="route('auctions.control', { auction: auction.id,  _query: {'view': 'control' }})">{{ auction.name }}</Link>
                </div>
                <div>
                    <Link :href="route('auctions.control', { auction: auction.id,  _query: {'view': 'control' }})">
                        <img :src="auction.image_url" class="w-7 h-auto"/>
                    </Link>
                </div>
                <div>
                    <Link :href="route('auctions.control', { auction: auction.id,  _query: {'view': 'control' }})">
                        <status :data="getAuctionState(auction)"/>
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
